import { render, staticRenderFns } from "./FeedLikers.vue?vue&type=template&id=0e6f1b08&scoped=true&"
import script from "./FeedLikers.vue?vue&type=script&lang=ts&"
export * from "./FeedLikers.vue?vue&type=script&lang=ts&"
import style0 from "./FeedLikers.vue?vue&type=style&index=0&id=0e6f1b08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6f1b08",
  null
  
)

export default component.exports